import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { CommonHttpService } from 'libs/common/src/lib/service/common-http.service';
import { debounceTime, distinctUntilChanged, fromEvent, map, switchMap } from 'rxjs';

@Component({
  selector: 'app-generic-search-dropdown',
  templateUrl: './generic-search-dropdown.component.html',
  styleUrls: ['./generic-search-dropdown.component.scss']
})
export class GenericSearchDropdownComponent {
  @Output() value = new EventEmitter();
  @Output() index = new EventEmitter();
  @Input() label?: string = '';
  @Input() options: any;
  @Input() title!: string;
  @Input() titleName: string = '';
  @Input() valueName!: string;
  @Input() captionItem!: string;
  @Input() showDropContainerTop: boolean = false;
  @Input() disabled = false;
  @Input() hasCaption: boolean = false;
  showDropDownOptions: boolean = false;
  icon = '';
  @Input() shouldEmitdisplayValue: boolean = false;
  @Input() shouldEmitIndex: boolean = false;
  @Input() shouldEmitEmittedValue: boolean = false;
  @Input() shouldEmitOption: boolean = false;
  @Input() shouldEmitDisplayValueAndEmittedValue!: boolean;
  @Input() isButton: boolean = false;
  hasSetupSearchInput = false;
  filteredOptions: any[] = []
  styleObject = {
    backgroundColor: '#2196f3',
    minWidth: '150px',
    display: 'flex',
    justifyContent: 'center'
  };
  constructor(private elementRef: ElementRef,
    private commonHttpService: CommonHttpService
  ) { }
  @ViewChild('searchInput') searchInput!: ElementRef;
  @HostListener('document:click', ['$event.target'])
  public onPageClick(targetElement: any) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    clickedInside
      ? (this.showDropDownOptions = !this.showDropDownOptions)
      : (this.showDropDownOptions = false);
    this.showOptions();
  }

  ngOnInit() {
    this.filteredOptions = this.options;
  }

  ngAfterViewChecked() {
    if (this.searchInput && !this.hasSetupSearchInput) {
      this.hasSetupSearchInput = true;

      fromEvent(this.searchInput.nativeElement, 'input')
        .pipe(
          map((event: any) => event.target.value.trim()),
          debounceTime(300),
          distinctUntilChanged(),
          switchMap(searchText => this.commonHttpService.searchWorkspaces(searchText))
        )
        .subscribe((results: any) => {
          this.filteredOptions = results.data.workspaces.map((workspace: any) => ({
            [this.titleName]: workspace[this.titleName]
          }))
        });
    }
  }

  showOptions(): void {
    if (this.disabled) {
      this.showDropDownOptions = false;
      return;
    }
  }

  getOption(
    displayValue: string,
    index: number,
    emitValue: string,
    option: string
  ): void {
    displayValue === undefined
      ? (this.title = option)
      : (this.title = displayValue);
    this.showDropDownOptions = false;
    this.filteredOptions = this.options;
    if (this.shouldEmitdisplayValue) {
      this.value.emit(displayValue); //value to be displayed in the title and options
    }
    if (this.shouldEmitOption) {
      this.value.emit(option);//when only  array of strings is passed
    }
    if (this.shouldEmitIndex) {
      this.index.emit(index); //index of the object that has been selected from array
    }
    if (this.shouldEmitEmittedValue) {
      this.value.emit(emitValue); //the value of the option
    }
    if (this.shouldEmitDisplayValueAndEmittedValue) {
      this.value.emit(displayValue + '  ' + emitValue);
    }
  }
}
